export const PREPAY_HISTORY_TEXT = "Prepay History"
export const PREPAY_HISTORY_VALUE = "prepay"

export const STATE_FILING_HISTORY_TEXT = "State Filing History"
export const STATE_FILING_HISTORY_VALUE = "statefiling"

export const FILING_HISTORY_TEXT = "Filing History"
export const FILING_HISTORY_VALUE = "filing"

export const W8_W9_REQUEST_HISTORY_TEXT = "W8W9 Request History"
export const W8_W9_REQUEST_HISTORY_VALUE = "w8w9request"

export const MEMBER_USER_HISTORY_TEXT = "Member User History"
export const MEMBER_USER_HISTORY_VALUE = "memberUserHistory"

export const STATE_PAYROLL_FILING_HISTORY_TEXT = "State Payroll Filing History"
export const STATE_PAYROLL_FILING_HISTORY_VALUE = "statepayrollfiling"


export const HISTORY_SECTION_ROUTES = {
    HISTORY: "history",
};

export const HISTORY_QUERY_PARAMS = {
    PAGE: "page",
};

export const HISTORY_LOADING_STATES = {
    FETCHING_STATES_LIST_LOADING: "FETCHING_STATES_LIST_LOADING",
    FETCHING_STATES_LIST_READY: "FETCHING_STATES_LIST_READY",
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READy",
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
    FETCHING_GRID_RECORDS_LOADING: "FETCHING_GRID_RECORDS_LOADING",
    FETCHING_GRID_RECORDS_READY: "FETCHING_GRID_RECORDS_READY",
}

export const HISTORY_MESSAGE_MAP = {
    [HISTORY_LOADING_STATES.FETCHING_STATES_LIST_LOADING]: "",
    [HISTORY_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [HISTORY_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "",
    [HISTORY_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]: "",
}